import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_component_base_button, _mergeProps({
    class: [ $options.getButtonClasses ]
  }, { ...$options.baseButtonProps, ..._ctx.$attrs }, {
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click', $event)))
  }), {
    default: _withCtx(() => [
      ($props.icon && !$options.isRightIcon)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.icon,
            "icon-namespace": $props.iconNamespace,
            class: _normalizeClass($options.iconClasses)
          }, null, 8 /* PROPS */, ["name", "icon-namespace", "class"]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default"),
      ($props.icon && $options.isRightIcon)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 1,
            name: $props.icon,
            "icon-namespace": $props.iconNamespace,
            class: _normalizeClass($options.iconClasses)
          }, null, 8 /* PROPS */, ["name", "icon-namespace", "class"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["class"]))
}